import React from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import ConferenceCallForm from "./ConferenceCallForm";

const ConferenceModal = ({
  closeCallModal,
  dialerServiceUrl,
  conferenceUuid,
  dialerServiceToken,
  startCall,
  show,
}) => (
  <Modal
    show={show}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-m-auto tw-flex tw-flex-col tw-gap-[32px] tw-max-w-[657px] tw-w-full tw-max-h-[90vh]"
  >
    <Modal.Body>
      <ConferenceCallForm
        closeCallModal={closeCallModal}
        dialerServiceUrl={dialerServiceUrl}
        conferenceUuid={conferenceUuid}
        dialerServiceToken={dialerServiceToken}
        startCall={startCall}
      />
    </Modal.Body>
  </Modal>
);

ConferenceModal.propTypes = {
  closeCallModal: PropTypes.func.isRequired,
  dialerServiceUrl: PropTypes.string.isRequired,
  conferenceUuid: PropTypes.string,
  dialerServiceToken: PropTypes.string,
  startCall: PropTypes.bool,
  show: PropTypes.bool,
};

ConferenceModal.defaultProps = {
  conferenceUuid: null,
  dialerServiceToken: null,
  startCall: false,
  show: false,
};

export default ConferenceModal;
